import { useEffect, useState } from 'react'

import { ClearSocketMessageHandler, GetActiveStadiumZones, GetUserZone, ResetAllResults, SetSocketMessageHandler } from './../../utilities/BL/Zones'
import { GetLotteryData, GetNewLotteryData, RemoveExtraClassesOfColorsDynamic, SaveLotteryData } from './../../utilities/BL/Games'

import { Welcome } from './Sections/Welcome'
import { Wait } from './Sections/Wait'
import { Quiz } from './Sections/Quiz'
import { Colors } from './Sections/Colors'
import { Thanks } from './Sections/Thanks'
import { InstructionsColors } from './Sections/InstructionsColor'
import { Lottery } from './Sections/Lottery'
import { Balloons } from './Sections/Balloons'
import { Riddle } from './Sections/Riddle'
import { QuizzWithImageAndOptions } from './Sections/QuizzWithImageAndOptions'
import { Noisemeter } from './Sections/Noisemeter'
import { FrontPageNoisemeter } from './Sections/Noisemeter/FrontPageNoisemeter'
import { FrontPageLuchoFest } from './Sections/LuchoFest/FrontPageLuchoFest'
import { LuchoFest } from './Sections/LuchoFest'
import { LightShow } from './Sections/LightShow'
import { Picnic } from './Sections/Picnic'
import { Tacos } from './Sections/Tacos'

// IMPORTAMOS EL NUEVO COMPONENTE V2 DEL AFICIONADO
import { GoalV2 } from './Sections/GoalV2'

import { DeleteSessionData } from './../../utilities/BL/Sessions'


const Sections = () => {
    // =========================================================================
    // 1. AJUSTE ORTOGRÁFICO: Debe coincidir EXACTAMENTE con VaronilZones del C#
    // =========================================================================

    const zonesTemplate = [
        { name: "Zona Laboratorio Tequis", text: "laboratorio tequis" },
        { name: "Zona Canels", text: "canels" },
        { name: "Zona Seguros El Potosí", text: "seguros el potosí" }, // <--- AGREGADO EL ACENTO
        { name: "Zona Red Cola", text: "red cola" },
        { name: "Zona Tecate", text: "tecate" },
        { name: "Zona Moctezuma", text: "moctezuma" },
        { name: "Zona Nissan", text: "nissan" },
        { name: "Zona Mobil", text: "mobil" },
        { name: "Zona Lounge Ron Potosí", text: "lounge ron potosí" }, // <--- AGREGADO EL ACENTO
        { name: "Zona Azul", text: "azul" },
        { name: "Zona Oro", text: "oro" },
        // Agnósticos Santos
        { name: "Santos Local", text: "zona1" },
        { name: "Santos Visitante", text: "zona2" },
        { name: "Team Santos Local", text: "zona1" },
        { name: "Team Santos Visitante", text: "zona2" },
        { name: "Team Lucho", text: "zona1" },
        { name: "Team Tunita", text: "zona2" }
    ]

    // Normal
    // const zonesTemplate = [
    //     { name: "Zona Laboratorio Tequis", text: "laboratorio tequis" },
    //     { name: "Zona Canels", text: "canels" },
    //     { name: "Zona Seguros El Potosí", text: "seguros el potosi" },
    //     { name: "Zona Red Cola", text: "red cola" },
    //     { name: "Zona Tecate", text: "tecate" },
    //     { name: "Zona Moctezuma", text: "moctezuma" },
    //     { name: "Zona Nissan", text: "nissan" },
    //     { name: "Zona Mobil", text: "mobil" },
    //     { name: "Zona Lounge Ron Potosí", text: "lounge ron potosi" },
    //     { name: "Zona Azul", text: "azul" },
    //     { name: "Zona Oro", text: "oro" }
    // ]

    const [isLoading, setIsLoading] = useState(true)
    const [zone, setZone] = useState(null)
    const [activeComponentId, setActiveComponentId] = useState(null)

    const [quizOptions, setQuizOptions] = useState([])
    const [quizQuestionId, setQuizQuestionId] = useState(null)
    const [color, setColor] = useState(null)
    const [lottery, setLottery] = useState(null)
    const [riddle, setRiddle] = useState(null)

    const [selectedZone, setSelectedZone] = useState(null)
    const [selectedZoneToComponent, setSelectedZoneToComponent] = useState(null)

    const [balloonConfig, setBalloonConfig] = useState(null)
    const [balloonWinners, setBalloonWinners] = useState(null)

    const [noisemeterConfig, setNoisemeterConfig] = useState(null);
    const [noisemeterWinners, setNoisemeterWinners] = useState(null);

    const [luchoFestConfig, setLuchoFestConfig] = useState(null);
    const [luchoFestEmergencyTrigger, setLuchoFestEmergencyTrigger] = useState(0);

    const [lightShowConfig, setLightShowConfig] = useState(null);

    const [displayZoneName, setDisplayZoneName] = useState('')

    // ==========================================
    // ESTADOS NUEVOS PARA TIRO A GOL V2
    // ==========================================
    const [goalV2Config, setGoalV2Config] = useState(null);
    const [goalV2MatchState, setGoalV2MatchState] = useState(null);
    const [goalV2WinnerZone, setGoalV2WinnerZone] = useState(null);

    // const ToCanonicalZone = (raw, zonesTemplate = []) => {
    //     if (!raw) return null
    //     let s = String(raw).toLowerCase().trim()
    //     if (s.startsWith("zona ")) s = s.slice(5)
    //     s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    //     s = s.replace(/\s+/g, " ").trim()
    //     if (Array.isArray(zonesTemplate) && zonesTemplate.length) {
    //         const canonList = zonesTemplate.map(z => ({
    //             canon: String(z.text).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, " ").trim(),
    //             original: z.text
    //         }))
    //         const hit = canonList.find(z => z.canon === s)
    //         if (hit) return hit.original
    //     }
    //     return s
    // }

    // =========================================================================
    // 2. FUNCIÓN DE NORMALIZACIÓN MÁS INTELIGENTE
    // =========================================================================
    const ToCanonicalZone = (raw, zonesTemplate = []) => {
        if (!raw) return null

        let s = String(raw).toLowerCase().trim()
        if (s.startsWith("zona ")) s = s.slice(5).trim()

        // Creamos una versión sin acentos para la comparación "sucia"
        const noAccents = (str) => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, " ").trim();
        const rawNoAccents = noAccents(s);

        if (Array.isArray(zonesTemplate) && zonesTemplate.length) {
            // Buscamos coincidencia relajada (sin acentos) pero retornamos la versión ESTRICTA (con acentos)
            const hit = zonesTemplate.find(z => noAccents(z.name.toLowerCase()) === rawNoAccents || noAccents(z.text) === rawNoAccents);
            if (hit) return hit.text; // Retorna "lounge ron potosí" (con acento)
        }

        return s;
    }

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
            document.body.classList.remove('Quiz__Background__Femenil--Blue')
            document.body.classList.remove('Quiz__Background__Femenil--Golden')

            const response = await GetUserZone()
            if (response.success) {
                const raw = response.data?.name
                const canon = ToCanonicalZone(raw, zonesTemplate)
                setZone({ ...response.data, canonical: canon })
                setSelectedZoneToComponent(canon)
                setSelectedZone(response.data.name)

                // NUEVO: Consultamos el nombre visual de la fase activa
                const zonesRes = await GetActiveStadiumZones();
                let visualName = raw; 
                if (zonesRes.success) {
                    const rawClean = raw.toLowerCase().replace("zona ", "").trim();
                    const matchedZone = zonesRes.data.find(z => 
                        z.internalName === rawClean || 
                        z.internalName === rawClean.replace("team ", "").trim() || 
                        z.displayName?.toLowerCase() === raw.toLowerCase()
                    );
                    if (matchedZone) {
                        visualName = matchedZone.displayName;
                    }
                }
                setDisplayZoneName(visualName);
            }
        } catch (error) {
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        LoadPage()

        const handler = async (payload) => {
            const type = payload?.type
            if (!type) return

            switch (type.toLowerCase()) {
                case "welcome":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(1)
                    break
                case "wait":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(2)
                    break
                case "trivia":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(3)
                    break
                case "options":
                    await RemoveExtraClassesOfColorsDynamic()
                    if (payload.data?.options?.length > 0) {
                        setQuizQuestionId(payload.data.questionId)
                        setQuizOptions(payload.data.options)
                        setColor(null)
                        setLottery(null)
                        setActiveComponentId(3.1)
                    }
                    break
                case "colores":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(4)
                    break
                case "setzonecolor":
                    if (payload?.color) {
                        setColor(payload.color)
                        setQuizQuestionId(null)
                        setQuizOptions(null)
                        setLottery(null)
                        setActiveComponentId(4.1)
                    }
                    break
                case "loteria":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(5)
                    break
                case "lotteryboard":
                    await RemoveExtraClassesOfColorsDynamic()
                    const response = await GetLotteryData(payload)
                    if (response.success) {
                        setColor(null); setQuizQuestionId(null); setQuizOptions(null);
                        setLottery(response.data)
                        setActiveComponentId(5.1)
                    } else {
                        const errorMessage = response?.message
                        if (errorMessage) {
                            console.log(errorMessage)
                        } else {
                            const responseNewData = await GetNewLotteryData(payload)
                            if (responseNewData.success) {
                                setColor(null); setQuizQuestionId(null); setQuizOptions(null);
                                setLottery(responseNewData.data)
                                await SaveLotteryData(responseNewData.data)
                                setActiveComponentId(5.1)
                            }
                        }
                    }
                    break
                case "start":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(7)
                    break
                case "thanks":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(8)
                    break

                // ==========================================
                // TIRO A GOL V2 (AFICIONADO)
                // ==========================================
                case "goal.created":
                    await RemoveExtraClassesOfColorsDynamic();
                    setGoalV2Config(payload.payload?.cfg || {});
                    setGoalV2MatchState({ matchId: payload.payload?.matchId, phase: 'WAITING' });
                    setGoalV2WinnerZone(null);
                    setActiveComponentId(15); // Pantalla de "Prepárate"
                    break;

                case "goal.started":
                    await RemoveExtraClassesOfColorsDynamic();
                    setGoalV2MatchState(prev => ({ ...prev, matchId: payload.payload?.matchId, phase: 'RUNNING' }));
                    setGoalV2WinnerZone(null);
                    setActiveComponentId(15.1); // Pantalla del Botón
                    break;

                case "goal.progress":
                    if (payload.payload?.elapsedMilliseconds !== undefined) {
                        setGoalV2MatchState(prev => ({ ...prev, ...payload.payload, phase: 'RUNNING' }));
                        setActiveComponentId(15.1);
                    }
                    break;

                case "goal.finished":
                    if (payload.payload?.finalZonesProgress !== undefined) {
                        await RemoveExtraClassesOfColorsDynamic();
                        setGoalV2MatchState(prev => ({ ...prev, phase: 'FINISHED' }));
                        setGoalV2WinnerZone(payload.payload?.winner);
                        setActiveComponentId(15.1);
                    }
                    break;

                case "goal.prepare":
                case "goal.reset":
                    await RemoveExtraClassesOfColorsDynamic();
                    setGoalV2MatchState({ matchId: payload.payload?.matchId, phase: 'WAITING' });
                    setGoalV2WinnerZone(null);
                    setActiveComponentId(15);
                    break;

                // ==========================================
                // OTRAS DINÁMICAS (Se mantienen intactas)
                // ==========================================
                case "ballons":
                    await RemoveExtraClassesOfColorsDynamic()
                    setBalloonConfig(null); setBalloonWinners(null);
                    setActiveComponentId(9)
                    break
                case "ballonsgame":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(9.1)
                    break;
                case "balloon.prepare": {
                    await RemoveExtraClassesOfColorsDynamic()
                    const d = payload.data || {}
                    setBalloonConfig({ matchId: d.matchId, startAt: d.startAt, endsAt: d.endsAt, targetTapsPerBalloon: d.targetTapsPerBalloon });
                    setBalloonWinners(null)
                    setActiveComponentId(9.1)
                    break;
                }
                case "balloon.show-winners": {
                    const d = payload.data || {}
                    setBalloonWinners({ winnerType: d.winnerType || "none", winners: d.winners || [], results: d.results || [] })
                    setActiveComponentId(9.1)
                    break
                }
                case "balloon.reset":
                    await RemoveExtraClassesOfColorsDynamic()
                    setBalloonConfig(null); setBalloonWinners(null);
                    setActiveComponentId(9)
                    break;
                case "riddle":
                    await RemoveExtraClassesOfColorsDynamic(); setActiveComponentId(10); break
                case "newquestionriddler":
                    await RemoveExtraClassesOfColorsDynamic()
                    sessionStorage.removeItem('eudnrlanrbaewq')
                    if (payload?.data) { setRiddle(payload.data); setActiveComponentId(10.1); }
                    break
                case "resumequestionriddler":
                case "riddledisplayitem":
                    await RemoveExtraClassesOfColorsDynamic()
                    if (payload?.data) { setRiddle(payload.data); setActiveComponentId(10.1); }
                    break
                case "quizzwithimageandoptions":
                    await RemoveExtraClassesOfColorsDynamic(); setActiveComponentId(10); break
                case "newquestionquizzwithimageandoptions":
                    await RemoveExtraClassesOfColorsDynamic()
                    sessionStorage.removeItem('eudnrlanrbaewq')
                    if (payload?.data) { setRiddle(payload.data); setActiveComponentId(11.1); }
                    break
                case "resumequestionquizzwithimageandoptions":
                    await RemoveExtraClassesOfColorsDynamic()
                    if (payload?.data) { setRiddle(payload.data); setActiveComponentId(11.1); }
                    break
                case "frontpagenoisemeter":
                    await RemoveExtraClassesOfColorsDynamic(); setNoisemeterConfig(null); setNoisemeterWinners(null); setActiveComponentId(12); break
                case 'noisemeter.prepare':
                    await RemoveExtraClassesOfColorsDynamic(); setNoisemeterConfig(payload.data); setNoisemeterWinners(null); setActiveComponentId(12.1); break;
                case 'noisemeter.finished':
                    setNoisemeterWinners(payload.data); setActiveComponentId(12.1); break;
                case "frontpageluchofest":
                    await RemoveExtraClassesOfColorsDynamic(); setLuchoFestConfig(null); setActiveComponentId(13); break
                case "luchofest.start":
                    await RemoveExtraClassesOfColorsDynamic(); setLuchoFestConfig(payload.data); setActiveComponentId(13.1); break
                case "luchofest.stop":
                    await RemoveExtraClassesOfColorsDynamic(); setLuchoFestConfig(null); setActiveComponentId(13); break
                case "luchofest.emergency_promo":
                    setLuchoFestEmergencyTrigger(prev => prev + 1); break
                case "lightshow.prepare":
                    await RemoveExtraClassesOfColorsDynamic(); setLightShowConfig({ ...payload.data, isRunning: false }); setActiveComponentId(14); break
                case "lightshow.start":
                    setLightShowConfig(prevConfig => ({ ...prevConfig, ...payload.data, isRunning: true })); break
                case "lightshow.stop":
                    setLightShowConfig(prevConfig => ({ ...prevConfig, isRunning: false })); break
                case "lightshow.late_join":
                    await RemoveExtraClassesOfColorsDynamic();
                    setLightShowConfig({ ...payload.data.config, isRunning: payload.data.isRunning, serverStartTimestampMilliseconds: payload.data.serverStartTimestampMilliseconds })
                    setActiveComponentId(14); break
                case "force_relogin":
                    // 1. Borramos la memoria local (zona guardada)
                    await DeleteSessionData();
                    // 2. Recargamos la página a la fuerza para mandarlo a Dashboard/Zones
                    window.location.reload(true); 
                    break;
                default:
                    await RemoveExtraClassesOfColorsDynamic(); setActiveComponentId(null); break
            }
        }

        SetSocketMessageHandler(handler)

        return () => {
            ClearSocketMessageHandler()
        }
    }, [])


    return (
        isLoading ? (
            <p>Cargando...</p>
        ) : (
            <>
                <div className="Sections">
                    <div className="Sections__Tiles">
                        {/* <p className='text-center'>Zona: {selectedZone}</p> */} {/* Normal */}

                        <p className='text-center'>Zona: {displayZoneName}</p>

                        {/* <p className='text-center'>Zona: */}
                            {/* Daikin */}
                            {/* {selectedZone.toLowerCase() === 'zona canels' && ' Pichon-kun'}
                            {selectedZone.toLowerCase() === 'zona tecate' && ' Tunita'}
                            {selectedZone.toLowerCase() === 'zona azul' && ' Pichon-kun'}
                            {selectedZone.toLowerCase() === 'zona oro' && ' Tunita'} */}

                            {/* La Moderna */}
                            {/* {selectedZone.toLowerCase() === 'zona canels' && ' Codito'}
                            {selectedZone.toLowerCase() === 'zona tecate' && ' Spaghetti'}
                            {selectedZone.toLowerCase() === 'zona azul' && ' Codito'}
                            {selectedZone.toLowerCase() === 'zona oro' && ' Spaghetti'} */}

                            {/* Normal */}
                            {/* {selectedZone.toLowerCase() === 'zona canels' && ' Lucho'}
                            {selectedZone.toLowerCase() === 'zona tecate' && ' Tunita'}
                            {selectedZone.toLowerCase() === 'zona azul' && ' Lucho'}
                            {selectedZone.toLowerCase() === 'zona oro' && ' Tunita'} */}
                        {/*</p>*/} {/* Para La Moderna */}

                        {activeComponentId === 1 && <Welcome />}
                        {activeComponentId === 2 && <Wait />}
                        {activeComponentId === 3 && <Wait />}
                        {activeComponentId === 3.1 && <Quiz questionId={quizQuestionId} options={quizOptions} />}
                        {activeComponentId === 4 && <InstructionsColors />}
                        {activeComponentId === 4.1 && <Colors color={color} />}
                        {activeComponentId === 5 && <Wait />}
                        {activeComponentId === 5.1 && <Lottery lottery={lottery} />}
                        {activeComponentId === 6 && <Wait />}
                        {activeComponentId === 7 && <Welcome />}
                        {activeComponentId === 8 && <Thanks />}
                        {activeComponentId === 9 && <Wait />}
                        {activeComponentId === 9.1 && (<Balloons config={balloonConfig} winners={balloonWinners} zone={selectedZoneToComponent} />)}
                        {activeComponentId === 10 && <Wait />}
                        {activeComponentId === 10.1 && <Riddle riddle={riddle} />}
                        {activeComponentId === 11.1 && <QuizzWithImageAndOptions quizz={riddle} />}
                        {activeComponentId === 12 && <FrontPageNoisemeter />}
                        {activeComponentId === 12.1 && (<Noisemeter config={noisemeterConfig} winners={noisemeterWinners} userZone={selectedZoneToComponent} />)}
                        {activeComponentId === 13 && <Wait />}
                        {activeComponentId === 13.1 && (<LuchoFest isPracticeRoundParameter={luchoFestConfig?.isPracticeRound} winningZoneParameter={luchoFestConfig?.winningZone} gameSequence={luchoFestConfig?.gameSequence} userZoneParameter={selectedZoneToComponent} emergencyTrigger={luchoFestEmergencyTrigger} />)}
                        {activeComponentId === 14 && (<LightShow config={lightShowConfig} />)}

                        {/* AQUI RENDERIZAMOS EL TIRO A GOL V2 PASANDO selectedZone PARA EVITAR DUPLICADOS */}
                        {activeComponentId === 15 && (<GoalV2 matchState={goalV2MatchState} config={goalV2Config} winnerZone={goalV2WinnerZone} userZone={selectedZoneToComponent} />)}
                        {activeComponentId === 15.1 && (<GoalV2 matchState={goalV2MatchState} config={goalV2Config} winnerZone={goalV2WinnerZone} userZone={selectedZoneToComponent} />)}

                        {!activeComponentId && <Welcome />}
                    </div>
                </div>
            </>
        )
    )
}

export { Sections };









// import { useEffect, useState } from 'react'

// import { ClearSocketMessageHandler, GetUserZone, ResetAllResults, SetSocketMessageHandler } from './../../utilities/BL/Zones'
// import { GetLotteryData, GetNewLotteryData, RemoveExtraClassesOfColorsDynamic, SaveLotteryData } from './../../utilities/BL/Games'

// import { Welcome } from './Sections/Welcome'
// import { Wait } from './Sections/Wait'
// import { Quiz } from './Sections/Quiz'
// import { Colors } from './Sections/Colors'
// import { Thanks } from './Sections/Thanks'
// import { InstructionsColors } from './Sections/InstructionsColor'
// import { Lottery } from './Sections/Lottery'
// import { Balloons } from './Sections/Balloons'
// import { Riddle } from './Sections/Riddle'
// import { QuizzWithImageAndOptions } from './Sections/QuizzWithImageAndOptions'
// import { Noisemeter } from './Sections/Noisemeter'
// import { FrontPageNoisemeter } from './Sections/Noisemeter/FrontPageNoisemeter'
// import { FrontPageLuchoFest } from './Sections/LuchoFest/FrontPageLuchoFest'
// import { LuchoFest } from './Sections/LuchoFest'
// import { LightShow } from './Sections/LightShow'
// import { Picnic } from './Sections/Picnic'
// import { GoalV2 } from './Sections/GoalV2'


// const Sections = () => {
//     const zonesTemplate = [
//         { name: "Zona Laboratorio Tequis", text: "laboratorio tequis" },
//         { name: "Zona Canels", text: "canels" },
//         { name: "Zona Seguros El Potosí", text: "seguros el potosi" }, // ¡ojo! sin acento para la clave
//         { name: "Zona Red Cola", text: "red cola" },
//         { name: "Zona Tecate", text: "tecate" },
//         { name: "Zona Moctezuma", text: "moctezuma" },
//         { name: "Zona Nissan", text: "nissan" },
//         { name: "Zona Mobil", text: "mobil" },
//         { name: "Zona Lounge Ron Potosí", text: "lounge ron potosi" },
//         { name: "Zona Azul", text: "azul" },
//         { name: "Zona Oro", text: "oro" }
//     ]

//     const [isLoading, setIsLoading] = useState(true)
//     const [zone, setZone] = useState(null)
//     const [activeComponentId, setActiveComponentId] = useState(null)

//     const [quizOptions, setQuizOptions] = useState([])
//     const [quizQuestionId, setQuizQuestionId] = useState(null)
//     const [color, setColor] = useState(null)
//     const [lottery, setLottery] = useState(null)
//     const [riddle, setRiddle] = useState(null)

//     const [selectedZone, setSelectedZone] = useState(null)
//     const [selectedZoneToComponent, setSelectedZoneToComponent] = useState(null)

//     // arriba, junto a otros useState
//     const [balloonConfig, setBalloonConfig] = useState(null)
//     // { matchId, startAt, endsAt, targetTapsPerBalloon }

//     const [balloonWinners, setBalloonWinners] = useState(null)
//     // { winnerType, winners:[], results:[] }

//     // --- ESTADOS NUEVOS PARA RUIDÓMETRO ---
//     const [noisemeterConfig, setNoisemeterConfig] = useState(null);
//     const [noisemeterWinners, setNoisemeterWinners] = useState(null);

//     // --- ESTADOS NUEVOS PARA LUCHO FEST ---
//     const [luchoFestConfig, setLuchoFestConfig] = useState(null);
//     // Este "trigger" es un número que cambiará cuando el Admin presione el botón de emergencia.
//     // Al cambiar, le avisará al componente hijo que debe mostrar la promo de inmediato.
//     const [luchoFestEmergencyTrigger, setLuchoFestEmergencyTrigger] = useState(0);

//     // --- ESTADOS NUEVOS PARA LIGHT SHOW ---
//     const [lightShowConfig, setLightShowConfig] = useState(null);

//     // --- ESTADOS NUEVOS PARA TIRO A GOL V2 ---
//     // Guarda la configuración inicial que manda el Admin (duración, batch de taps)
//     const [goalV2Config, setGoalV2Config] = useState(null);
//     // Guarda el progreso en vivo (fase, milisegundos transcurridos y el array de zonas)
//     const [goalV2MatchState, setGoalV2MatchState] = useState(null);
//     // Guarda el ganador al finalizar la partida ("norte", "sur", "tie", etc.)
//     const [goalV2WinnerZone, setGoalV2WinnerZone] = useState(null);


//     // utils/zones.js
//     // Pasa "Zona Tecate" -> "tecate", "Zona Seguros El Potosí" -> "seguros el potosi"
//     const ToCanonicalZone = (raw, zonesTemplate = []) => {
//         if (!raw) return null

//         // 1) lower, trim, elimina prefijo "zona " si existe
//         let s = String(raw).toLowerCase().trim()
//         if (s.startsWith("zona ")) s = s.slice(5)

//         // 2) quita acentos/diacríticos
//         s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, "")

//         // 3) colapsa espacios internos
//         s = s.replace(/\s+/g, " ").trim()

//         // 4) si proveemos plantilla, mapea por el campo .text
//         if (Array.isArray(zonesTemplate) && zonesTemplate.length) {
//             const canonList = zonesTemplate.map(z => ({
//                 // "seguros el potosí" -> "seguros el potosi"
//                 canon: String(z.text).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, " ").trim(),
//                 original: z.text
//             }))
//             const hit = canonList.find(z => z.canon === s)
//             if (hit) return hit.original // devuelve EXACTAMENTE la clave que espera el server (tu .text)
//         }

//         return s // fallback sensato
//     }

//     const LoadPage = async () => {
//         try {
//             document.getElementById("root").classList.add("BodyComplete")

//             document.body.classList.remove('Quiz__Background__Femenil--Blue')
//             document.body.classList.remove('Quiz__Background__Femenil--Golden')

//             const response = await GetUserZone()
//             if (response.success) {
//                 // setZone(response.data)
//                 const raw = response.data?.name // viene algo como "Zona Tecate"
//                 const canon = ToCanonicalZone(raw, zonesTemplate) // "tecate"
//                 setZone({ ...response.data, canonical: canon })
//                 setSelectedZoneToComponent(canon)
//                 setSelectedZone(response.data.name)
//             }
//         } catch (error) {

//         } finally {
//             setIsLoading(false)
//         }
//     }

//     useEffect(() => {
//         LoadPage()


//         const handler = async (payload) => {
//             const type = payload?.type
//             if (!type) {
//                 return
//             }

//             if (type === '') {
//                 return
//             }

//             switch (type.toLowerCase()) {
//                 case "welcome":
//                     await RemoveExtraClassesOfColorsDynamic()
//                     setActiveComponentId(1)
//                     break

//                 case "wait":
//                     await RemoveExtraClassesOfColorsDynamic()
//                     setActiveComponentId(2)
//                     break

//                 case "trivia":
//                     await RemoveExtraClassesOfColorsDynamic()
//                     setActiveComponentId(3)
//                     break

//                 case "options":
//                     await RemoveExtraClassesOfColorsDynamic()

//                     if (payload.data?.options?.length > 0) {
//                         setQuizQuestionId(payload.data.questionId)
//                         setQuizOptions(payload.data.options)
//                         setColor(null)
//                         setLottery(null)
//                         setActiveComponentId(3.1)
//                     }
//                     break

//                 case "colores":
//                     await RemoveExtraClassesOfColorsDynamic()
//                     setActiveComponentId(4)
//                     break

//                 case "setzonecolor":
//                     if (payload?.color) {
//                         setColor(payload.color)
//                         setQuizQuestionId(null)
//                         setQuizOptions(null)
//                         setLottery(null)
//                         setActiveComponentId(4.1)
//                     }
//                     break

//                 case "loteria":
//                     await RemoveExtraClassesOfColorsDynamic()
//                     setActiveComponentId(5)
//                     break

//                 case "lotteryboard":
//                     await RemoveExtraClassesOfColorsDynamic()

//                     // Obtener datos de tabla nueva de cookie
//                     // Si existe, revisar si es el mismo juego.
//                     //      Si es el mismo, entonces checo cookies e imprimo.
//                     //      Si es nuevo imprimir ese con esto que ya tenía.
//                     // Si no, hacer esto que tenía.

//                     const response = await GetLotteryData(payload)

//                     if (response.success) {
//                         setColor(null)
//                         setQuizQuestionId(null)
//                         setQuizOptions(null)
//                         setLottery(response.data)
//                         setActiveComponentId(5.1)
//                     } else {
//                         const errorMessage = response?.message

//                         if (errorMessage) {
//                             console.log(errorMessage)
//                         } else {
//                             const responseNewData = await GetNewLotteryData(payload)

//                             if (responseNewData.success) {
//                                 setColor(null)
//                                 setQuizQuestionId(null)
//                                 setQuizOptions(null)
//                                 setLottery(responseNewData.data)
//                                 // Guardar datos de tabla en las cookies
//                                 await SaveLotteryData(responseNewData.data)
//                                 setActiveComponentId(5.1)
//                             } else {
//                                 console.log(responseNewData.message)
//                             }
//                         }
//                     }
//                     break

//                 case "start": // Antes recommendations
//                     await RemoveExtraClassesOfColorsDynamic()
//                     setActiveComponentId(7)
//                     break

//                 case "thanks":
//                     await RemoveExtraClassesOfColorsDynamic()
//                     setActiveComponentId(8)
//                     break

//                 // ====== GLOBOS ======
//                 case "ballons": // layout de espera para globos
//                     await RemoveExtraClassesOfColorsDynamic()
//                     setBalloonConfig(null)
//                     setBalloonWinners(null)
//                     setActiveComponentId(9)         // tu "Wait" para globos
//                     break

//                 case "ballonsgame": // vista de juego (UI), todavía sin tiempos
//                     await RemoveExtraClassesOfColorsDynamic()
//                     // puedes entrar directo a la pantalla del juego; el countdown llegará con balloon.prepare
//                     setActiveComponentId(9.1)
//                     break;

//                 case "balloon.prepare": {
//                     await RemoveExtraClassesOfColorsDynamic()
//                     const d = payload.data || {}
//                     // d: { matchId, startAt, endsAt, targetTapsPerBalloon }
//                     setBalloonConfig({
//                         matchId: d.matchId,
//                         startAt: d.startAt,
//                         endsAt: d.endsAt,
//                         targetTapsPerBalloon: d.targetTapsPerBalloon
//                     });
//                     setBalloonWinners(null)       // limpia winners si venían de una partida previa
//                     setActiveComponentId(9.1)     // entra a la pantalla de juego
//                     break;
//                 }

//                 case "balloon.show-winners": {
//                     // se emite al terminar: pantalla y móviles
//                     const d = payload.data || {}
//                     // d: { matchId, winnerType, winners:[], results:[] }
//                     setBalloonWinners({
//                         winnerType: d.winnerType || "none",
//                         winners: d.winners || [],
//                         results: d.results || []
//                     })
//                     // mantenemos 9.1 para que <Ballons /> muestre la vista final
//                     setActiveComponentId(9.1)
//                     break
//                 }

//                 case "balloon.reset":
//                     await RemoveExtraClassesOfColorsDynamic()
//                     // volver a espera de globos
//                     setBalloonConfig(null)
//                     setBalloonWinners(null)
//                     setActiveComponentId(9)
//                     break;

//                 case "riddle": // Al ingresar al Tile del juego
//                     await RemoveExtraClassesOfColorsDynamic()
//                     setActiveComponentId(10)
//                     break

//                 case "newquestionriddler": // Al enviar una nueva adivinanza
//                     await RemoveExtraClassesOfColorsDynamic()

//                     // Borrar info de sesión cuando cambio de pregunta o adivinanza
//                     sessionStorage.removeItem('eudnrlanrbaewq')

//                     if (payload?.data) {
//                         setRiddle(payload.data)
//                         setActiveComponentId(10.1)
//                     }
//                     break

//                 case "resumequestionriddler": // Al reanudar la adivinanza
//                     await RemoveExtraClassesOfColorsDynamic()

//                     if (payload?.data) {
//                         setRiddle(payload.data)
//                         setActiveComponentId(10.1)
//                     }
//                     break

//                 case "riddledisplayitem": // Al mostrar el elemento oculto de la adivinanza
//                     await RemoveExtraClassesOfColorsDynamic()

//                     if (payload?.data) {
//                         setRiddle(payload.data)
//                         setActiveComponentId(10.1)
//                     }
//                     break

//                 // Trivia con imágenes y preguntas
//                 case "quizzwithimageandoptions": // Al ingresar al Tile del juego
//                     await RemoveExtraClassesOfColorsDynamic()
//                     setActiveComponentId(10)
//                     break

//                 case "newquestionquizzwithimageandoptions": // Al enviar una nueva adivinanza
//                     await RemoveExtraClassesOfColorsDynamic()

//                     // Borrar info de sesión cuando cambio de pregunta o adivinanza
//                     sessionStorage.removeItem('eudnrlanrbaewq')

//                     if (payload?.data) {
//                         setRiddle(payload.data)
//                         setActiveComponentId(11.1)
//                     }
//                     break

//                 case "resumequestionquizzwithimageandoptions": // Al reanudar la adivinanza
//                     await RemoveExtraClassesOfColorsDynamic()

//                     if (payload?.data) {
//                         setRiddle(payload.data)
//                         setActiveComponentId(11.1)
//                     }
//                     break

//                 // CASO 1: Pantalla de Espera / Portada del Ruidómetro
//                 case "frontpagenoisemeter":
//                     await RemoveExtraClassesOfColorsDynamic()
//                     setNoisemeterConfig(null)
//                     setNoisemeterWinners(null)
//                     setActiveComponentId(12) // Muestra componente de espera o intro
//                     break
//                 // await RemoveExtraClassesOfColorsDynamic()
//                 // setActiveComponentId(12)
//                 // break

//                 // CASO 2: Preparar / Iniciar Juego
//                 case 'noisemeter.prepare':
//                     await RemoveExtraClassesOfColorsDynamic();
//                     // payload.data trae: { matchId, startAt, endsAt, targetZone, idTile }
//                     setNoisemeterConfig(payload.data);
//                     setNoisemeterWinners(null);
//                     setActiveComponentId(12.1); // Muestra componente interactivo
//                     break;
//                 // await RemoveExtraClassesOfColorsDynamic()
//                 // setActiveComponentId(12.1)
//                 // break

//                 // CASO 3: Finalizar Juego / Mostrar Ganadores
//                 case 'noisemeter.finished':
//                     // payload.data trae el snapshot final con { winnerZone }
//                     setNoisemeterWinners(payload.data);
//                     // Mantenemos 12.1 para que el componente muestre la pantalla de "Ganaste/Perdiste"
//                     setActiveComponentId(12.1);
//                     break;
//                 // await RemoveExtraClassesOfColorsDynamic()
//                 // setActiveComponentId(12.1)
//                 // break

//                 // case "frontpageluchofest":
//                 //     await RemoveExtraClassesOfColorsDynamic()
//                 //     setNoisemeterConfig(null)
//                 //     setNoisemeterWinners(null)
//                 //     setActiveComponentId(13) // Muestra componente de espera o intro
//                 //     break

//                 // ==========================================
//                 // LUCHO FEST
//                 // ==========================================
//                 case "frontpageluchofest":
//                     await RemoveExtraClassesOfColorsDynamic()
//                     setLuchoFestConfig(null)
//                     // Muestra la pantalla de espera o portada (ID 13)
//                     setActiveComponentId(13)
//                     break

//                 case "luchofest.start":
//                     await RemoveExtraClassesOfColorsDynamic()
//                     // Guardamos TODA la configuración que mandó el Admin (Fases, ganador, etc.)
//                     setLuchoFestConfig(payload.data)
//                     // Activamos el componente del juego (ID 13.1)
//                     setActiveComponentId(13.1)
//                     break

//                 case "luchofest.stop":
//                     await RemoveExtraClassesOfColorsDynamic()
//                     setLuchoFestConfig(null)
//                     // Abortamos y regresamos a la pantalla de espera
//                     setActiveComponentId(13)
//                     break

//                 case "luchofest.emergency_promo":
//                     // NO cambiamos el ID del componente porque queremos mantenernos en la pantalla del juego,
//                     // pero sumamos 1 al trigger para que LuchoFest.js detecte la emergencia.
//                     setLuchoFestEmergencyTrigger(prev => prev + 1)
//                     break

//                 // case "lightshow.prepare":
//                 //     await RemoveExtraClassesOfColorsDynamic()
//                 //     // Muestra la pantalla de espera o portada (ID 14)
//                 //     setActiveComponentId(14)
//                 //     break

//                 // case "lightshow.start":
//                 //     await RemoveExtraClassesOfColorsDynamic()
//                 //     // Muestra la pantalla de espera o portada (ID 14)
//                 //     setActiveComponentId(14)
//                 //     break

//                 // case "lightshow.stop":
//                 //     await RemoveExtraClassesOfColorsDynamic()
//                 //     // Muestra la pantalla de espera o portada (ID 14)
//                 //     setActiveComponentId(14)
//                 //     break

//                 // ==========================================
//                 // LIGHT SHOW PRO (Show de Luces)
//                 // ==========================================
//                 case "lightshow.prepare":
//                     await RemoveExtraClassesOfColorsDynamic()
//                     // Guardamos la configuración (BPM y Color) y marcamos que AÚN NO arranca
//                     setLightShowConfig({
//                         ...payload.data,
//                         isRunning: false
//                     })
//                     setActiveComponentId(14)
//                     break

//                 case "lightshow.start":
//                     // // El Admin presionó Iniciar. Solo cambiamos la bandera a 'true'.
//                     // // No cambiamos el ID del componente porque el usuario ya está ahí.
//                     // setLightShowConfig(prevConfig => ({
//                     //     ...prevConfig,
//                     //     isRunning: true
//                     // }))

//                     // El Admin puede darle Start múltiples veces con nuevos BPM,
//                     // solo actualizamos la config y el nuevo timestamp
//                     setLightShowConfig(prevConfig => ({
//                         ...prevConfig,
//                         ...payload.data, // Si mandaron nuevos BPM viajan aquí
//                         isRunning: true
//                     }))
//                     break

//                 case "lightshow.stop":
//                     // await RemoveExtraClassesOfColorsDynamic()
//                     // setLightShowConfig(null)
//                     // // Al detener, regresamos al usuario a la portada de espera normal
//                     // setActiveComponentId(2) // Asumiendo que 2 es tu componente <Wait /> genérico

//                     // ¡CLAVE! NO cambiamos de ActiveComponentId.
//                     // Solo apagamos el motor para que el usuario mantenga permisos y se quede en Standby.
//                     setLightShowConfig(prevConfig => ({ ...prevConfig, isRunning: false }))
//                     break

//                 // CASO NUEVO: Cuando un usuario entra cuando el show ya está armado o corriendo
//                 case "lightshow.late_join":
//                     await RemoveExtraClassesOfColorsDynamic()
//                     setLightShowConfig({
//                         ...payload.data.config,
//                         isRunning: payload.data.isRunning,
//                         serverStartTimestampMilliseconds: payload.data.serverStartTimestampMilliseconds
//                     })
//                     setActiveComponentId(14)
//                     break

//                 // ==========================================
//                 // TIRO A GOL V2 (CARRERA POR TIEMPO)
//                 // ==========================================

//                 case "goal.created":
//                     await RemoveExtraClassesOfColorsDynamic();

//                     // Obtenemos la configuración enviada por el C# dentro de payload.payload.cfg
//                     const createdConfig = payload.payload?.cfg || {};
//                     setGoalV2Config(createdConfig);

//                     setGoalV2MatchState({
//                         matchId: payload.payload?.matchId,
//                         phase: 'WAITING'
//                     });
//                     setGoalV2WinnerZone(null);

//                     // Asignamos el ID 15 para la pantalla de "Prepárate"
//                     setActiveComponentId(15);
//                     break;

//                 case "goal.started":
//                     await RemoveExtraClassesOfColorsDynamic();

//                     // Actualizamos la fase a RUNNING para habilitar el botón
//                     setGoalV2MatchState(previousState => ({
//                         ...previousState,
//                         matchId: payload.payload?.matchId,
//                         phase: 'RUNNING'
//                     }));
//                     setGoalV2WinnerZone(null);

//                     // Asignamos el ID 22.1 para la pantalla interactiva de Tap
//                     setActiveComponentId(15.1);
//                     break;

//                 case "goal.progress":
//                     // Esta es la validación clave: Si el backend manda tiempo, es la V2.
//                     if (payload.payload?.elapsedMilliseconds !== undefined) {
//                         setGoalV2MatchState(previousState => ({
//                             ...previousState,
//                             ...payload.payload,
//                             phase: 'RUNNING'
//                         }));

//                         // Mantenemos la pantalla activa (útil si el aficionado recargó la página a medio juego)
//                         setActiveComponentId(15.1);
//                     } else {
//                         // Aquí podrías dejar la lógica original de tu V1 si decides mantener ambas activas,
//                         // o simplemente ignorarlo si ya migraste al 100%.
//                     }
//                     break;

//                 case "goal.finished":
//                     // Validamos si es la V2 buscando el nodo finalZonesProgress (que no existe en V1)
//                     if (payload.payload?.finalZonesProgress !== undefined) {
//                         await RemoveExtraClassesOfColorsDynamic();

//                         setGoalV2MatchState(previousState => ({
//                             ...previousState,
//                             phase: 'FINISHED'
//                         }));
//                         setGoalV2WinnerZone(payload.payload?.winner);

//                         // Mantenemos el componente 15.1 para que el aficionado vea quién ganó
//                         setActiveComponentId(15.1);
//                     }
//                     break;

//                 case "goal.reset":
//                     await RemoveExtraClassesOfColorsDynamic();

//                     // Regresamos el estado a cero y volvemos a la pantalla de espera
//                     setGoalV2MatchState({
//                         matchId: payload.payload?.matchId,
//                         phase: 'WAITING'
//                     });
//                     setGoalV2WinnerZone(null);
//                     setActiveComponentId(15);
//                     break;

//                 default:
//                     await RemoveExtraClassesOfColorsDynamic()
//                     setActiveComponentId(null)
//                     break
//             }
//         }

//         SetSocketMessageHandler(handler)

//         return () => {
//             ClearSocketMessageHandler()
//         }
//     }, [])


//     return (
//         isLoading ? (
//             <p>Cargando...</p>
//         ) : (
//             <>
//                 <div className="Sections">
//                     <div className="Sections__Tiles">
//                         <p className='text-center'>Zona: {selectedZone}</p>

//                         {activeComponentId === 1 && <Welcome />}
//                         {activeComponentId === 2 && <Wait />}
//                         {activeComponentId === 3 && <Wait />}
//                         {activeComponentId === 3.1 && <Quiz questionId={quizQuestionId} options={quizOptions} />}
//                         {activeComponentId === 4 && <InstructionsColors />}
//                         {activeComponentId === 4.1 && <Colors color={color} />}
//                         {activeComponentId === 5 && <Wait />} {/* <InstructionsLottery /> */}
//                         {activeComponentId === 5.1 && <Lottery lottery={lottery} />}
//                         {activeComponentId === 6 && <Wait />}
//                         {/* {activeComponentId === 6.1 && }  */}
//                         {activeComponentId === 7 && <Welcome />}
//                         {activeComponentId === 8 && <Thanks />}
//                         {activeComponentId === 9 && <Wait />}
//                         {activeComponentId === 9.1 && (<Balloons config={balloonConfig} winners={balloonWinners} zone={selectedZoneToComponent} />)}
//                         {activeComponentId === 10 && <Wait />}
//                         {activeComponentId === 10.1 && <Riddle riddle={riddle} />}
//                         {activeComponentId === 11.1 && <QuizzWithImageAndOptions quizz={riddle} />}
//                         {/* {activeComponentId === 12 && <Wait />} */}
//                         {activeComponentId === 12 && <FrontPageNoisemeter />}
//                         {activeComponentId === 12.1 && (<Noisemeter config={noisemeterConfig} winners={noisemeterWinners} userZone={selectedZoneToComponent} />)}
//                         {activeComponentId === 13 && <Wait />} {/* FrontPageLuchoFest */}
//                         {activeComponentId === 13.1 && (<LuchoFest isPracticeRoundParameter={luchoFestConfig?.isPracticeRound} winningZoneParameter={luchoFestConfig?.winningZone} gameSequence={luchoFestConfig?.gameSequence} userZoneParameter={selectedZoneToComponent} emergencyTrigger={luchoFestEmergencyTrigger} />)}
//                         {activeComponentId === 14 && (<LightShow config={lightShowConfig} />)}
//                         {activeComponentId === 15 && (<GoalV2 matchState={goalV2MatchState} config={goalV2Config} winnerZone={goalV2WinnerZone} userZone={selectedZoneToComponent} />)}
//                         {activeComponentId === 15.1 && (<GoalV2 matchState={goalV2MatchState} config={goalV2Config} winnerZone={goalV2WinnerZone} userZone={selectedZoneToComponent} />)}
//                         {/* {!activeComponentId && <Picnic />} */}
//                         {!activeComponentId && <Welcome />}
//                     </div>
//                 </div>
//             </>
//         )
//     )
// }

// export { Sections };